var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupplierApplicationPendingPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 144,
    viewBox: "0 0 121 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.973 34.5947L120.249 50.1222L112.387 59.3759L109.754 57.1391C108.694 56.2387 108.126 54.8877 108.224 53.5006C108.346 51.7666 107.636 50.0779 106.311 48.9524L106.023 48.7076C104.739 47.6164 102.998 47.2316 101.373 47.6799C100.073 48.0386 98.6802 47.7308 97.6527 46.8578L94.1106 43.8484L101.973 34.5947Z",
    fill: "#9BAEBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4557 17.3863C68.4557 18.5139 67.5497 19.4232 66.4262 19.4232H37.3967C36.8531 19.4232 36.3095 19.205 35.9471 18.8049C35.5846 18.4411 35.3672 17.9319 35.3672 17.3499C35.3672 16.2224 36.2732 15.3131 37.3967 15.3131H38.0491C38.0491 15.2039 38.0491 15.0948 38.0491 15.0221C38.0491 9.63885 41.0933 4.98311 45.5511 2.6916L46.6021 9.27513C46.7108 9.89347 47.2907 10.3299 47.9068 10.2572C48.2692 10.1845 48.5953 9.96621 48.7403 9.63886C48.849 9.42062 48.8853 9.16601 48.849 8.9114L47.798 2.21876C47.6168 1.05482 48.5229 0 49.6826 0H54.0678C55.2275 0 56.1336 1.05482 55.9524 2.21876L54.9014 8.9114C54.7926 9.52974 55.2275 10.1481 55.8799 10.2572C56.496 10.3663 57.1121 9.92984 57.1846 9.27513L58.2356 2.6916C62.802 5.01948 65.8826 9.85709 65.7738 15.3494H66.4624C67.006 15.3494 67.5497 15.5677 67.9121 15.9678C68.2383 16.3315 68.4557 16.8407 68.4557 17.3863Z",
    fill: "#EB9928"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0317 22.9326C64.5552 32.512 58.8742 40.0707 51.9104 40.0707C44.9465 40.0707 39.2655 32.512 38.7891 22.9326",
    stroke: "#2F4858",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 52.8652C21.25 47.8947 25.2794 43.8652 30.25 43.8652H65.5051C67.9698 43.8652 70.3266 44.876 72.0255 46.6616L87.1994 62.6103L98.3553 50.2401C102 48.0002 107.918 51.1508 106.931 56.4632C104.5 61.2822 100.346 66.5651 96.5 70.5002C95.7014 71.3173 94.9419 72.2022 94.1698 73.1245C90.5095 77.4961 84.2135 77.1733 80.3208 73.0073L69.365 61.2822V84.6946H34.4551V63.4451C34.4551 62.523 33.7075 61.7755 32.7854 61.7755C31.8633 61.7755 31.1158 62.523 31.1158 63.4451V84.6946H21.25V52.8652Z",
    fill: "#2F4858"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 73.0518,
    width: 22.9816,
    height: 11.1426,
    fill: "#9BAEBC",
    stroke: "#F1F4F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5781,
    y: 73.0518,
    width: 22.9816,
    height: 11.1426,
    fill: "#9BAEBC",
    stroke: "#F1F4F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6602,
    y: 87.123,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6602,
    y: 116.872,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 101.998,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 131.443,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0703,
    y: 87.123,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0703,
    y: 116.872,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4102,
    y: 101.998,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4102,
    y: 131.443,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4805,
    y: 87.123,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4805,
    y: 116.872,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8203,
    y: 101.998,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8203,
    y: 131.443,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 79.2305,
    y: 101.998,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 79.2305,
    y: 131.443,
    width: 23.9816,
    height: 12.1426,
    fill: "#9BAEBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierApplicationPendingPerson);
export default __webpack_public_path__ + "static/media/SupplierApplicationPendingPerson.434da4deff159aac2885c6157d9e2c53.svg";
export { ForwardRef as ReactComponent };